import React, { useState, useEffect, forwardRef } from 'react';
import {
  Box,
  Text,
  Badge,
  Group,
  Divider,
  Select,
  Loader,
} from '@mantine/core';
import { useMedplum } from '@medplum/react';
import { getPatientName } from '../EligibiltyService';
import { circularPlatformLogo } from '../../../utils';

interface PatientProps {
  onChange: (value: any) => void;
  size:string;
  radius:string;
}



interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
  value: string;
  label: string;
  gender?: string;
  dob?: string;
  ehrdata?: string[];
  lastupdated?: string;
}

const SearchPatient: React.FC<PatientProps> = ({ onChange,size,radius }) => {
  const medplum = useMedplum();
  const [patientList, setPatientList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedPatient, setSelectedPatient] = useState<any>();

  const getPatientList = async () => {
    setIsLoading(true);
    try {
      const res = await medplum.searchResources('Patient', '_count=500');
      const patientData = res.map((patient) => {
        const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
          (coding) => coding.system?.includes('cerner')
        );
        const containsAthena = patient?.identifier?.some(
          (item) => item.system && item.system.includes('athena')
        );
        let ehrtype = '';
        if (
          patient?.identifier?.find(
            (id) =>
              id.system === 'urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0'
          )
        ) {
          ehrtype = 'EPIC';
        } else if (containsCerner) {
          ehrtype = 'Cerner';
        } else if (containsAthena) {
          ehrtype = 'Athena Health';
        } else {
          ehrtype = 'Others';
        }

        const EHRIcon = (
          <img
            src={ehrtype === 'EPIC' ? circularPlatformLogo["epic"] : ehrtype === 'Cerner' ? circularPlatformLogo["cerner"] : ehrtype === 'Athena Health' ? circularPlatformLogo["athenahealth"] : circularPlatformLogo["others"]}
            style={{ marginRight: '10px', width: '30px' }}
            alt={ehrtype}
          />
        );

        return {
          label: getPatientName(patient.name),
          value: patient.id,
          ehr: ehrtype,
          icon: EHRIcon,
        };
      });

      setPatientList(patientData);
      if (patientData.length > 0) {
        setSelectedPatient(patientData[0].value);
        onChange(patientData[0].value);
      }
    } catch (error) {
      console.error('Failed to fetch patient list:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPatientList();
  }, []);

  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, ehrdata, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: 'space-between',
            height: '30px',
            width: '100%',
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{ehrdata?.[0]}</div>
        </Group>
      </div>
    )
  );

  return (
    <Select
    label={'Select Patient'}
      placeholder={isLoading ? 'Loading...' : 'Search Patient'}
      required
      data={patientList}
      rightSection={isLoading ? <Loader size="sm" /> : null}
    //   mt="sm"
      size={size}
      radius={radius}
      value={selectedPatient}
      onChange={(val) => {
        console.log(val,'val')
        setSelectedPatient(val);
        onChange(val); // Pass the selected value to the parent component
      }}
      clearable
      sx={{
        '.mantine-Select-itemsWrapper': {
          paddingRight: '10px',
        },
      }}
      searchable
      itemComponent={SelectItem}
    />
  );
};

export default SearchPatient;
